export const EventSliderCardCss = {
  eventWrapMain: {
    width: "100%",
    padding: "0 15px"
    //marginLeft: '10px'
  },
  eventWrap: {
    overflow: "hidden",
    position: "relative" as const,
    borderRadius: "10px"
  },
  eventImage: {
    position: "relative" as const,
    overflow: "hidden",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  eventContent: {
    position: "absolute" as const,
    left: 0,
    right: 0,
    textAlign: "center" as const,
    zIndex: 5,
    bottom: "0px",
    height: "100%",
    transition: "all 0.4s ease 0s",
    background:
      "rgba(0, 0, 0, 0) -webkit-gradient(linear, left bottom, left top, color-stop(25%, #072e4a), color-stop(60%, transparent)) repeat scroll 0% 0%",
    borderRadius: "10px"
  },
  img: {
    borderRadius: "10px",
    transition: "all 0.5s ease 0s",
    minHeight: "385px",
    objectFit: "contain" as const
  },
  teamSlider: {
    display: "flex" as const,
    height: "auto",
    position: "relative" as const,
    flexDirection: "column" as const,
    alignItems: "center" as const,
    justifyContent: "center" as const,
    paddingTop: "1vw",
    paddingBottom: "1vw"
  },
  teamSlideImage: {
    display: "block" as const,
    width: "60%",
    height: "auto",
    maxHeight: "100%",
    objectFit: "contain" as const
  },
  watchNowBtn: {
    padding: "6px 12px",
    borderRadius: "4px",
    color: "#ffffff",
    backgroundColor: "#f4181c",
    display: "inline-block",
    lineHeight: 1,
    borderColor: "transparent",
    hover: {
      backgroundColor: "#efefef"
    }
  },
  eventTitle: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: "600",
    margin: "0 0 3px",
    WebkitTransition: "all 0.5s ease 0s",
    transition: "all 0.5s ease 0s",
    textDecoration: "none"
  }
};
